import React from 'react';
import { Field } from 'formik';
import { Slider } from 'antd';

export const SliderComponent = ({ name, title, leftLegend, rightLegend }) => {
  const marks = {
    0: '0',
    1: '1',
    2: '2',
    3: '3',
    4: '4',
    5: '5',
    6: '6',
    7: '7',
    8: '8',
    9: '9',
    10: '10',
  };

  const trackPointsLabel = [
    'No pain',
    'Hardly notice pain',
    'Notice pain, does not interfere with activities',
    'Sometimes distracts me',
    'Distracts me, can do usual activities',
    'Interrupts some activities',
    'Hard to ignore, avoid usual activities',
    'Focus of attention, prevents doing daily activities',
    'Awful, hard to do anything',
    "Can't bear the pain, unable to do anything",
    'As bad as it could be, nothing else matters',
  ];

  return (
    <Field name={name}>
      {({ meta, form: { setFieldValue } }) => (
        <div className="w-full my-5">
          <div>{title}</div>
          <Slider
            style={{ fontFamily: 'Poppins' }}
            max={10}
            min={-1}
            onChange={(value) => {
              setFieldValue(name, value);
              analytics.track('Slider Changed', {
                question: title,
                answer: value,
              });
            }}
            marks={marks}
            tooltip={{
              formatter: (value) =>
                value === -1
                  ? 'Choose a value between 0 and 10 referring the above picture'
                  : trackPointsLabel[value],
            }}
            styles={{
              track: {
                background: 'transparent',
                fontFamily: 'Poppins',
              },
              tracks: {
                background: 'transparent',
                fontFamily: 'Poppins',
              },
              rail: {
                background:
                  'linear - gradient(142deg, rgba(55, 124, 2, 0.964) 0 %, rgba(57, 255, 0, 1) 36 %, rgba(244, 241, 4, 1) 44 %, rgba(255, 255, 144, 1) 49 %, rgba(231, 242, 7, 1) 66 %, rgb(197, 0, 0) 100 %)',
                fontFamily: 'Poppins',
              },
            }}
          />
          <div className="flex justify-between font-medium italic text-[11px] font-sans">
            <div>{leftLegend}</div>
            <div>{rightLegend}</div>
          </div>
          {meta.touched && meta.error && (
            <div className="error">{meta.error}</div>
          )}
        </div>
      )}
    </Field>
  );
};
